import { createRouter, createWebHistory } from 'vue-router'
import { trackRouter } from 'vue-gtag-next'
import routes from './routes'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
})

// Google Analytics
trackRouter(router, {
  // TODO: ページタイトルの設定はどうする？
  template: to => ({
    page_title: 'かんたん資料請求ナビ',
    page_path: `${import.meta.env.BASE_URL.replace(/\/$/, '')}${to.path}`,
  }),
})

export default router
